module.exports = __webpack_public_path__ + "static/media/success_icon.01956a8b.svg";